import {AlertWrapper} from "./styles";

export const Alert = ({type, children , visible}) => {
    return <AlertWrapper visible={visible} type={type} >{children}</AlertWrapper>;
}

